import { createI18n } from 'vue-i18n'
import { api } from '@/api/client'
import ruElementLocale from 'element-plus/es/locale/lang/ru'
import tkBaseElementLocale from 'element-plus/es/locale/lang/tk'
import dayjs from 'dayjs'
import 'dayjs/locale/tk'
import 'dayjs/locale/ru'

// Custom Turkmen translation for Element Plus components with complete datepicker & table strings
export const tkElementLocale = {
  ...tkBaseElementLocale,
  name: 'tk',
  el: {
    ...tkBaseElementLocale.el,
    pagination: {
      ...tkBaseElementLocale.el.pagination,
      goto: 'Geç',
      pagesize: '/sahypa',
      total: 'Jemi {total}',
      pageClassifier: '',
      deprecationWarning: ''
    },
    table: {
      ...tkBaseElementLocale.el.table,
      emptyText: 'Maglumat tapylmady',
      confirmFilter: 'Tassykla',
      resetFilter: 'Arassala',
      clearFilter: 'Ählisi',
      sumText: 'Jemi'
    },
    messagebox: {
      ...tkBaseElementLocale.el.messagebox,
      title: 'Habar',
      confirm: 'Hawa',
      cancel: 'Ýatyr',
      error: 'Ýalňyşlyk'
    },
    datepicker: {
      ...tkBaseElementLocale.el.datepicker,
      now: 'Häzir',
      today: 'Şu gün',
      cancel: 'Ýatyr',
      clear: 'Arassala',
      confirm: 'Tassykla',
      selectDate: 'Sene saýlaň',
      selectTime: 'Wagt saýlaň',
      startDate: 'Başlangyç sene',
      startTime: 'Başlangyç wagt',
      endDate: 'Gutarýan sene',
      endTime: 'Gutarýan wagt',
      prevYear: 'Öňki ýyl',
      nextYear: 'Indiki ýyl',
      prevMonth: 'Öňki aý',
      nextMonth: 'Indiki aý',
      year: '',
      month1: 'Ýanwar',
      month2: 'Fewral',
      month3: 'Mart',
      month4: 'Aprel',
      month5: 'Maý',
      month6: 'Iýun',
      month7: 'Iýul',
      month8: 'Awgust',
      month9: 'Sentýabr',
      month10: 'Oktýabr',
      month11: 'Noýabr',
      month12: 'Dekabr',
      weeks: {
        sun: 'Ýek',
        mon: 'Duş',
        tue: 'Siş',
        wed: 'Çar',
        thu: 'Pen',
        fri: 'Ann',
        sat: 'Şen'
      },
      weeksFull: {
        sun: 'Ýekşenbe',
        mon: 'Duşenbe',
        tue: 'Sişenbe',
        wed: 'Çarşenbe',
        thu: 'Penşenbe',
        fri: 'Anna',
        sat: 'Şenbe'
      },
      months: {
        jan: 'Ýan',
        feb: 'Few',
        mar: 'Mar',
        apr: 'Apr',
        may: 'Maý',
        jun: 'Iýn',
        jul: 'Iýl',
        aug: 'Awg',
        sep: 'Sen',
        oct: 'Okt',
        nov: 'Noý',
        dec: 'Dek'
      }
    }
  }
}

export const baseTk = {
  menu: {
    main: 'Esasy',
    dashboard: 'Dashboard',
    birthdays: 'Doglan günleri',
    academic: 'Esasy (Okuw bölümi)',
    classes: 'Synplar',
    stages: 'Tapgyrlar',
    shifts: 'Smenalar',
    branches: 'Şahamçalar',
    rooms: 'Otaglar',
    categories: 'Kategoriýalar',
    subjects: 'Dersler',
    relatives: 'Hossarlar',
    students: 'Okuwçylar',
    allStudents: 'Ähli okuwçylar',
    studentClasses: 'Okuwçylar we Synplar',
    timetable: 'Sapak tertibi',
    finance: 'Maliýe we Tölegler',
    invoices: 'Tölegler (Invoices)',
    invoicesMenu: 'Tölegler',
    prices: 'Nyrhlar',
    dcoin: 'Dcoin Dolandyryş',
    cms: 'CMS & Saýt Mazmuny',
    banners: 'Bannerler',
    blog: 'Makalalar / Täzelikler',
    siteEvents: 'Çäreler',
    eventRegistrations: 'Çärelere Ýazylanlar',
    summerCamp: 'Tomusky dynç alyş',
    feedback: 'Seslenmeler',
    comments: 'Teswirler',
    gallery: 'Surat Galereýasy',
    videos: 'Wideo Sapaklar',
    testResults: 'Synag Netijeleri',
    localization: 'Terjimeler',
    reports: 'Hasabatlar',
    generalReport: 'Umumy hasabat',
    booksReport: 'Kitaplar hasabaty',
    attendancesReport: 'Gatnaşyk hasabaty',
    performanceReport: 'Başarnyk hasabaty',
    stagesReport: 'Tapgyrlar hasabaty',
    salariesReport: 'Zähmet haky hasabaty',
    duplicateCardsReport: 'Gaýtalanýan kartoçkalar',
    cateringReport: 'Naharlaryň Hasabaty',
    dailyInvoicesReport: 'Gündelik Tölegler',
    unpaidStudentsReport: 'Töleg Etmedik Talyplar',
    administration: 'Administrator',
    adminUsers: 'Ulanyjylar',
    roles: 'Hukuklar',
    qrScanner: 'QR Skaner'
  },
  topbar: {
    home: 'Esasy',
    site: 'Saýty aç',
    changePassword: 'Açar sözi çalşyrmak',
    logout: 'Ulgamdan çykmak',
    user: 'Ulanyjy'
  },
  login: {
    title: 'Ulgama girmek',
    email: 'Email',
    password: 'Açar sözi',
    rememberMe: 'Meni ýatda sakla',
    submit: 'Girmek',
    loggingIn: 'Girilýär...',
    backToSite: 'Baş sahypa',
    invalidCredentials: 'Email ýa-da açar sözi nädogry.',
    lockedOut: 'Hasabyňyz wagtlaýynça petiklendi.',
    networkError: 'Serwer bilen birigip bolmady.',
    emailRequired: 'Email giriziň',
    emailInvalid: 'Dogry email salgysyny giriziň',
    passwordRequired: 'Açar sözüni giriziň',
    motto1: 'Ýöriteleşdirilen',
    motto2: 'Tizleşdirilen',
    motto3: 'Döwrebap',
    brandName: 'Dury Zehin',
    brandTagline: 'Dürli ugurlar boýunça ýokary hilli bilim bermek we geljekki nesilleri kämilleşdirmek'
  },
  common: {
    save: 'Ýatda sakla',
    cancel: 'Ýatyr',
    edit: 'Üýtget',
    delete: 'Poz',
    add: 'Goş',
    search: 'Gözleg...',
    filter: 'Filtrle',
    reset: 'Arassala',
    actions: 'Amallar',
    total: 'Jemi',
    status: 'Ýagdaýy',
    back: 'Yza',
    confirm: 'Tassykla',
    success: 'Üstünlikli',
    error: 'Ýalňyşlyk',
    warning: 'Duýduryş',
    empty: 'Maglumat tapylmady',
    loading: 'Ýüklenýär...'
  }
}

export const baseRu = {
  menu: {
    main: 'Главная',
    dashboard: 'Dashboard',
    birthdays: 'Дни рождения',
    academic: 'Учебный отдел',
    classes: 'Группы (Классы)',
    stages: 'Этапы',
    shifts: 'Смены',
    branches: 'Филиалы',
    rooms: 'Кабинеты',
    categories: 'Категории',
    subjects: 'Предметы',
    relatives: 'Родственники',
    students: 'Ученики',
    allStudents: 'Все ученики',
    studentClasses: 'Ученики и группы',
    timetable: 'Расписание',
    finance: 'Финансы и оплата',
    invoices: 'Счета / Оплата',
    invoicesMenu: 'Счета',
    prices: 'Тарифы / Цены',
    dcoin: 'Управление Dcoin',
    cms: 'CMS и контент сайта',
    banners: 'Баннеры',
    blog: 'Статьи / Новости',
    siteEvents: 'Мероприятия',
    eventRegistrations: 'Заявки на мероприятия',
    summerCamp: 'Летний лагерь',
    feedback: 'Отзывы',
    comments: 'Комментарии',
    gallery: 'Фотогалерея',
    videos: 'Видеоуроки',
    testResults: 'Результаты тестов',
    localization: 'Переводы',
    reports: 'Отчёты',
    generalReport: 'Общий отчёт',
    booksReport: 'Отчёт по книгам',
    attendancesReport: 'Отчёт по посещаемости',
    performanceReport: 'Отчёт по успеваемости',
    stagesReport: 'Отчёт по этапам',
    salariesReport: 'Отчёт по зарплате',
    duplicateCardsReport: 'Повторные карточки',
    cateringReport: 'Отчёт по питанию',
    dailyInvoicesReport: 'Ежедневные платежи',
    unpaidStudentsReport: 'Неоплатившие студенты',
    administration: 'Администратор',
    adminUsers: 'Пользователи',
    roles: 'Роли',
    qrScanner: 'QR Сканер'
  },
  topbar: {
    home: 'Главная',
    site: 'Открыть сайт',
    changePassword: 'Сменить пароль',
    logout: 'Выйти из системы',
    user: 'Пользователь'
  },
  login: {
    title: 'Вход в систему',
    email: 'Email',
    password: 'Пароль',
    rememberMe: 'Запомнить меня',
    submit: 'Войти',
    loggingIn: 'Вход...',
    backToSite: 'На главную',
    invalidCredentials: 'Неверный email или пароль.',
    lockedOut: 'Учетная запись временно заблокирована.',
    networkError: 'Не удалось подключиться к серверу.',
    emailRequired: 'Введите email',
    emailInvalid: 'Введите корректный email',
    passwordRequired: 'Введите пароль',
    motto1: 'Специализированное',
    motto2: 'Ускоренное',
    motto3: 'Современное',
    brandName: 'Dury Zehin',
    brandTagline: 'Качественное образование по различным направлениям и развитие будущих поколений'
  },
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    edit: 'Редактировать',
    delete: 'Удалить',
    add: 'Добавить',
    search: 'Поиск...',
    filter: 'Фильтровать',
    reset: 'Сбросить',
    actions: 'Действия',
    total: 'Всего',
    status: 'Статус',
    back: 'Назад',
    confirm: 'Подтвердить',
    success: 'Успешно',
    error: 'Ошибка',
    warning: 'Предупреждение',
    empty: 'Данные не найдены',
    loading: 'Загрузка...'
  }
}

const savedLang = (localStorage.getItem('dz_lang') as 'tk' | 'ru') || 'tk'
dayjs.locale(savedLang)

export const i18n = createI18n({
  legacy: false,
  locale: savedLang,
  fallbackLocale: 'tk',
  messages: {
    tk: baseTk,
    ru: baseRu
  }
})

/**
 * Loads dynamic localization strings from the database table via API
 * and merges them into the active vue-i18n instance.
 */
export async function loadDbTranslations(lang?: 'tk' | 'ru') {
  const targetLang = lang || (i18n.global.locale as any).value || 'tk'
  try {
    const bundle = await api.get(`/api/admin/cms/localization/bundle?lang=${targetLang}`)
    if (bundle && typeof bundle === 'object') {
      const currentMessages = i18n.global.getLocaleMessage(targetLang) || {}
      // Deep merge: database strings override base defaults, flat keys are preserved
      i18n.global.setLocaleMessage(targetLang, {
        ...currentMessages,
        ...bundle
      })
    }
  } catch (err) {
    console.warn('Could not fetch DB localization bundle:', err)
  }
}

export function getElementLocale(lang: 'tk' | 'ru') {
  return lang === 'ru' ? ruElementLocale : tkElementLocale
}
